export default __webpack_public_path__ + "f83a8b8886694eaef4505dd80af7a430.png";